interface Props {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger = false,
  onConfirm,
  onCancel,
}: Props) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div className="w-full max-w-sm mx-4 rounded-[16px] bg-card border-[0.5px] border-border shadow-xl p-6">
        <h2 className="text-[15px] font-semibold text-foreground mb-2">
          {title}
        </h2>
        <p className="text-[13px] text-muted-foreground mb-6">{message}</p>
        <div className="flex justify-end gap-2">
          <button
            onClick={onCancel}
            className="px-4 py-3 rounded-[8px] text-[13px] font-medium text-muted-foreground hover:text-foreground hover:bg-[var(--surface-muted)] transition-colors cursor-pointer"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-3 rounded-[8px] text-[13px] font-medium transition-colors cursor-pointer ${
              danger
                ? "bg-red-500 text-white hover:bg-red-600"
                : "bg-foreground text-[var(--page-bg)] hover:opacity-80"
            }`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
